<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="modal-content">
  <div class="modal-header">
    <div class="modal-title" [xdaTranslate]="'SDE_CREDITS'"></div>
    <div class="modal-close">
      <button
        type="button"
        class="modal-close-btn"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true" class="xgl-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" tabindex="-1">
    @if (loading) {
      <div id="credits-loading" class="blanket flex-center">
        <span class="xrx-activity-indicator ai-lg ai-spin"></span>
      </div>
    }
    @if (!loading) {
      <div class="credits-loaded">
        <div class="remaining-credits">
          <p>
            <span>{{ creditsString }}</span> &nbsp;
            <span class="remaining-units font-weight-bold">{{ units }}</span>
          </p>
        </div>
        <div class="credits-description">
          <p>{{ creditsLabel }}</p>
          @if (isAdvancedPlan) {
            <p class="mb-0" [xdaTranslate]="'SDE_EXAMPLE1'"></p>
          }
          @if (isAdvancedPlan) {
            <p>{{ exampleLabel }}</p>
          }
        </div>
        <div class="credit-exceptions">
          <p xdaTranslate>SDE_FOLLOWING_USE_ADDITIONAL</p>
          @if (isAdvancedPlan) {
            <p class="mb-0"><strong xdaTranslate>SDE_DRM</strong></p>
          }
          @if (isAdvancedPlan) {
            <p>{{ protectString }}</p>
          }
          <p class="mb-0"><strong xdaTranslate>SDE_DOCUMENT_MERGE</strong></p>
          <p>{{ mergeString }}</p>
          @if (isAdvancedPlan) {
            <p class="mb-0"><strong xdaTranslate>AUTOMATED</strong></p>
          }
          @if (isAdvancedPlan) {
            <p>{{ automateString }}</p>
          }
          <p>
            <a
              href="https://www.support.xerox.com/en-us/product/xerox-workflow-central-service/documentation"
              target="_blank"
              xdaTranslate
              >SDE_SEE_USER_GUIDE</a
            >
          </p>
        </div>
      </div>
    }
  </div>
</div>
